import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
    routes: [
      {
        path: '/',
        name: 'home',
        component: () => import('./pages/home/index.vue'),
        meta : {
          public: true
        }
      },

      // ---------------------------------
      // NFD Academy
      // ---------------------------------

      {
        path: '/nfd-academy/nft-101',
        name: 'nft-101',
        component: () => import('./pages/nft-101/index.vue')
      },
      {
        path: '/nfd-academy/glossary',
        name: 'glossary',
        component: () => import('./pages/glossary/index.vue')
      },
      {
        path: '/nfd-academy/web3-workshops',
        name: 'web3-workshops',
        component: () => import('./pages/web3-workshops/index.vue')
      },
      {
        path: '/nfd-academy/scholarship',
        name: 'scholarship',
        component: () => import('./pages/scholarship/index.vue')
      },
      {
        path: '/nfd-academy/philanthropic',
        name: 'philanthropic',
        component: () => import('./pages/philanthropic/index.vue')
      },
      {
        path: '/nfd-academy/security-and-safety',
        name: 'security-and-safety',
        component: () => import('./pages/security-and-safety/index.vue')
      },
      {
        path: '/nfd-academy/mental-health',
        name: 'mental-health',
        component: () => import('./pages/mental-health/index.vue')
      },

      // ---------------------------------
      // XXXXXX
      // ---------------------------------

      {
        path: '/events/web3-workshops',
        name: 'web3-workshops',
        component: () => import('./pages/web3-workshops/index.vue')
      },
      {
        path: '/events/meta-music-hall',
        name: 'meta-music-hall',
        component: () => import('./pages/meta-music-hall/index.vue')
      },
      {
        path: '/events/twitter-spaces',
        name: 'twitter-spaces',
        component: () => import('./pages/twitter-spaces/index.vue')
      },
      {
        path: '/events/community-spotlight',
        name: 'community-spotlight',
        component: () => import('./pages/community-spotlight/index.vue')
      },
      {
        path: '/events/fathers-day-5k',
        name: 'fathers-day-5k',
        component: () => import('./pages/fathers-day-5k/index.vue')
      },
      {
        path: '/events/past-events',
        name: 'past-events',
        component: () => import('./pages/past-events/index.vue')
      },

      // ---------------------------------
      // THE PROJECT
      // ---------------------------------

      {
        path: '/token/mint',
        name: 'mint',
        component: () => import('./pages/mint/index.vue')
      },
      {
        path: '/token/roadmap',
        name: 'roadmap',
        component: () => import('./pages/roadmap/index.vue')
      },
      {
        path: '/token/faq',
        name: 'faq',
        component: () => import('./pages/faq/index.vue')
      },
      {
        path: '/token/merch',
        name: 'merch',
        component: () => import('./pages/merch/index.vue')
      },

      // ---------------------------------
      // UTILITY
      // ---------------------------------

      {
        path: '/utility',
        name: 'utility',
        component: () => import('./pages/utility/index.vue')
      },

      // ---------------------------------
      // TEAM
      // ---------------------------------

      {
        path: '/team/about',
        name: 'about',
        component: () => import('./pages/about/index.vue')
      },
      {
        path: '/team/our-y',
        name: 'our-y',
        component: () => import('./pages/our-y/index.vue')
      },
      {
        path: '/team/socials',
        name: 'socials',
        component: () => import('./pages/socials/index.vue')
      },
      {
        path: '/team/portfolio',
        name: 'portfolio',
        component: () => import('./pages/portfolio/index.vue')
      },
      {
        path: '/team/partners',
        name: 'partners',
        component: () => import('./pages/partners/index.vue')
      },
      {
        path: '/team/contact',
        name: 'contact',
        component: () => import('./pages/contact/index.vue')
      },

      /*

      {
        path: '/skinned-games',
        name: 'skinned-games',
        component: () => import('./pages/skinned-games/index.vue')
      },
      {
        path: '/nfd-academy',
        name: 'nfd-academy',
        component: () => import('./pages/nfd-academy/index.vue')
      },
      {
        path: '/marketplace',
        name: 'marketplace',
        component: () => import('./pages/marketplace/index.vue')
      },
      {
        path: '/newsletter',
        name: 'newsletter',
        component: () => import('./pages/newsletter/index.vue')
      },

      {
        path: '/gallery',
        name: 'gallery',
        component: () => import('./pages/gallery/index.vue')
      },
      */


      // ---------------------------------
      // LEGAL
      // ---------------------------------
      {
        path: '/legal/terms',
        name: 'terms',
        component: () => import('./pages/terms/index.vue')
      },
      {
        path: '/legal/privacy',
        name: 'privacy',
        component: () => import('./pages/privacy/index.vue')
      },
      {
        path: '/legal/california-privacy',
        name: 'californiaprivacy',
        component: () => import('./pages/california-privacy/index.vue')
      },
      {
        path: '*',
        name: '404',
        component: () => import('./pages/404.vue')
      }
    ]
})

export default router